import { render, staticRenderFns } from "./DetailedAssessment.vue?vue&type=template&id=23d60588&scoped=true"
import script from "./DetailedAssessment.vue?vue&type=script&lang=js"
export * from "./DetailedAssessment.vue?vue&type=script&lang=js"
import style0 from "./DetailedAssessment.vue?vue&type=style&index=0&id=23d60588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d60588",
  null
  
)

export default component.exports